// storage-browser.js
// IndexedDB-backed storage implementing the exact same {load, save}
// interface Node's FileStorage classes do (see identity.js,
// group-trust.js) — this is what lets identity-core.js and
// group-trust-core.js run completely unchanged in a browser: they only
// ever call storage.load()/storage.save(data), never anything
// filesystem- or IndexedDB-specific themselves.
//
// One shared database, one object store, keyed entries — 'identity' and
// 'group-trust' are the two keys this project actually uses, but this
// class itself is generic (any string key works), matching how Node's
// FileStorage is generic over any file path.

const DB_NAME = 'p2p-core'
const DB_VERSION = 1
const STORE_NAME = 'kv'

function openDb () {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION)
    req.onupgradeneeded = () => {
      req.result.createObjectStore(STORE_NAME)
    }
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error)
  })
}

export class IndexedDbStorage {
  constructor (key) {
    this.key = key
  }

  async load () {
    const db = await openDb()
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly')
      const req = tx.objectStore(STORE_NAME).get(this.key)
      req.onsuccess = () => resolve(req.result ?? null)
      req.onerror = () => reject(req.error)
    })
  }

  async save (data) {
    const db = await openDb()
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite')
      tx.objectStore(STORE_NAME).put(data, this.key)
      tx.oncomplete = () => resolve()
      tx.onerror = () => reject(tx.error)
    })
  }
}
